<template>
  <div class="regular-query-item">
    <Row style="display: flex; align-items: center;margin-right:60px">
      <Col span="10" style="text-align: left"><label>{{search.label}}：</label></Col>
      <Col span="17">
        <div class="query-item-obj">
          <component
              :is="getDisplayComponent(search.component)"
              :ref="search.name"
              :name="search.name"
              :search="search"
              @getSearchValueChange="getSearchValueChange"
              @enter="enter"
          >
          </component>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
import QueryInput from './input' // 输入框
import QuerySelect from './select' // 下拉单选
import QueryMultSelect from './multSelect' // 下拉多选
import QueryDateRange from './dateRange' // 日期区间选择
import QueryCascader from './cascader' // 联级选择

export default {
  components: {QueryInput, QuerySelect, QueryMultSelect, QueryDateRange, QueryCascader},
  created () {
  },
  props: {
    search: {
      type: Object
    }
  },
  methods: {
    getDisplayComponent (display) {
      return 'Query' + display.replace(display.charAt(0), display.charAt(0).toUpperCase());
    },
    getSearchValueChange (curObj) {
      if (curObj.component === 'dateRange' || curObj.component === 'numberRange') {
        if (curObj.value && (curObj.value[0] || curObj.value[1])) {
          this.$emit('setSearchValueChange', curObj);
        } else {
          this.$emit('clearSearchValueChange', curObj);
        }
      } else if ((curObj.component === 'cascader')) {
        if (curObj.value && curObj.value.length > 0) {
          this.$emit('setSearchValueChange', curObj);
        } else {
          this.$emit('clearSearchValueChange', curObj);
        }
      } else {
        if ((curObj.value === null) || (typeof curObj.value === 'string' && curObj.value.length === 0)) {
          this.$emit('clearSearchValueChange', curObj);
        } else {
          this.$emit('setSearchValueChange', curObj);
        }
      }
    },
    enter () {
      // this.$emit('enterSearch');
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/regularQuery/queryObj.vue